import {combineReducers} from 'redux';
import {SEARCH_TERMS_CHANGE, MOBILE_SEARCH_TOGGLE, SEARCH, _REQUEST, _SUCCESS, TOGGLE_MENU, OPEN_MOBILE_MODE} from './reducers-const';

function text(state = '', action) {
  switch (action.type) {
    case SEARCH_TERMS_CHANGE:
      return action.data;
    default:
      return state;
  }
}

function hasResults(state = false, action) {
  switch (action.type) {
    case MOBILE_SEARCH_TOGGLE:
      return action.data;
    default:
      return state;
  }
}

function sending(state = false, action) {
  switch (action.type) {
    case `${SEARCH}${_SUCCESS}`:
      return false;
    case `${SEARCH}${_REQUEST}`:
      return true;
    default:
      return false;
  }
}

function toggle(state = false, action) {
  switch (action.type) {
    case `${TOGGLE_MENU}`:
      return action.data;
    default:
      return state;
  }
}

function openMobileMode(state = false, action) {
  switch (action.type) {
    case `${OPEN_MOBILE_MODE}`:
      return action.data;
    default:
      return state;
  }
}

export interface Search {
  text?: string;
  hasResults?: boolean;
  sending?: boolean;
  toggle?: boolean;
  openMobileMode?: boolean;
}

export default combineReducers<Search>({
  text,
  hasResults,
  sending,
  toggle,
  openMobileMode
});
